import { render, staticRenderFns } from "./WeightSubmissionModal.vue?vue&type=template&id=de1ba7bc&"
import script from "./WeightSubmissionModal.vue?vue&type=script&lang=js&"
export * from "./WeightSubmissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports